import IconButton from "@mui/material/IconButton";

import {BmAlertIcon, BmCloseIcon} from "~/components/icons/simpleIcons";
import {designColors} from "~/ui";
import {BmBaseInfoBanner, BmBaseInfoBannerProps, commonStyles} from "~/components/banners";

export interface BmErrorNotificationBannerProps
  extends Omit<BmBaseInfoBannerProps, "bodySx" | "colorPreset" | "leftColumn" | "rightColumn"> {
  closeButton?: boolean;
  onClose?: VoidFunction;
}

export const BmErrorNotificationBanner: React.FC<BmErrorNotificationBannerProps> = ({
  closeButton,
  onClose,
  ...restProps
}) => {
  return (
    <BmBaseInfoBanner
      {...restProps}
      bodySx={{flexWrap: "nowrap", "& *": {color: designColors.colorInk}}}
      colorPreset="red"
      leftColumn={<BmAlertIcon id="alert-icon" color={designColors.colorInk} className={commonStyles.icon} size="xs" />}
      rightColumn={
        closeButton ? (
          <IconButton onClick={onClose} disableRipple size="small">
            <BmCloseIcon id="close-icon" color={designColors.colorInk} />
          </IconButton>
        ) : undefined
      }
    />
  );
};
